module.exports = __webpack_public_path__ + "static/media/grimace.fa27b565.svg";